"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { columns } from "../opportunities/table-componentsEZ/columns";
import { OpportunitiesDataTable } from "../opportunities/table-componentsEZ/data-table";
const OpportunitiesView = ({
  data,
  leadId,
  crmData,
  accountId,
}: {
  data: any;
  leadId?: string;
  crmData: any;
  accountId?: string;
}) => {

  console.log("crmData:", crmData);
  console.log("opportunities:", data);
  
  const router = useRouter();
  const [isMounted, setIsMounted] = useState(false);

  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  const { users, accounts, contacts,saleTypes, saleStages, saleStages2, saleStages3, campaigns } =
    crmData;

  //console.log(accountId, "accountId");
  return (
    <Card className="shadow-lg"> {/* Add the shadow utility class here */}

       <CardHeader className="pb-3">
        <div className="flex justify-between">
          <div>
            <CardTitle
            >
        Deals 
            </CardTitle>
            <CardDescription></CardDescription>
          </div>
          <div className="flex space-x-2">
       
          </div>
        </div>
     
      </CardHeader>

<CardContent>
{!data ||
  (data.length === 0 ? (
    "No assigned opportunities found"
  ) : (
    <OpportunitiesDataTable data={data} columns={columns} />
  ))}
</CardContent>

</Card>
  );
};

export default OpportunitiesView;